import { httpService } from "./http.service";

const BASE_URL = "images";

export const imageService = {
    addImage,
    getImageByUUID,
    deleteImageByUUID
};

async function addImage(obj, accountId) {
    try {
        const payload = { ...obj, accountId };
        const data = await httpService.post(`${BASE_URL}/image/add`, payload);
        return data;
    } catch (error) {
        console.error('Failed to add a image:', error);
        throw error;
    }
}

async function getImageByUUID(uuid) {
    try {
        const data = await httpService.get(`${BASE_URL}/image/findByUUID/${uuid}`);
        return data;
    } catch (error) {
        console.error('Failed to get a image:', error);
        throw error;
    }
}

async function deleteImageByUUID(uuid) {
    const data = await httpService.delete(`${BASE_URL}/image/delete/${uuid}`);
    return data;
}